import React from "react";

const CertificateManagementIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30.346"
      height="43.874"
      viewBox="0 0 30.346 43.874"
    >
      <path
        id="db55"
        d="M306.778,233.93H279.43a1.467,1.467,0,0,0-1.463,1.463v34.295a1.467,1.467,0,0,0,1.463,1.463h3.949V267.2a9.261,9.261,0,0,1-1.828-5.411,9.067,9.067,0,1,1,18.134,0,8.783,8.783,0,0,1-1.828,5.411v3.949h8.994a1.467,1.467,0,0,0,1.463-1.463V235.393a1.584,1.584,0,0,0-1.536-1.463ZM300.2,245.118H286.011a1.463,1.463,0,0,1,0-2.925h14.113a1.467,1.467,0,0,1,1.463,1.463,1.406,1.406,0,0,1-1.39,1.463Zm-9.652,25.667a9.13,9.13,0,0,0,5.045-1.536v7.239a1.3,1.3,0,0,1-.731,1.17,1.057,1.057,0,0,1-.512.146,1.1,1.1,0,0,1-.8-.293l-3-2.413-3,2.413a1.227,1.227,0,0,1-1.316.146,1.3,1.3,0,0,1-.731-1.17v-7.239a8.741,8.741,0,0,0,5.046,1.536Zm6.873-8.994a6.873,6.873,0,1,1-6.873-6.873A6.866,6.866,0,0,1,297.418,261.791Z"
        transform="translate(-277.967 -233.93)"
        fill={fill ? fill : "#43cfe5"}
      />
    </svg>
  );
};

export default CertificateManagementIcon;
